import React from 'react';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskCmdbAssetsDashboardsRoute } from '@atlassian/jira-router-routes-servicedesk-cmdb-routes/src/servicedeskCmdbAssetsDashboardsRoute.tsx';
import { workspaceResource } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/index.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { Redirect } from '@atlassian/react-resource-router';
import { isNewReportsNavExperienceEnabled } from '@atlassian/jira-insight-reports-v2/src/common/feature-gate-helpers.tsx';
import { DashboardList } from '@atlassian/jira-insight-reports-v2/src/ui/dashboard-list/index.tsx';
import { AssetsAppBase } from '@atlassian/jira-spa-assets-app-base/src/ui/index.tsx';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { AssetsReportsNav4HomePage } from './ui/reports/index.tsx';

const DashboardsListPage = () => (
	<AssetsAppBase appName={APP_NAMES.INSIGHT_ASSETS_REPORTS}>
		{({ workspaceId }) => <DashboardList workspaceId={workspaceId} />}
	</AssetsAppBase>
);

export const servicedeskCmdbAssetsDashboardsRouteEntry = createEntry(
	servicedeskCmdbAssetsDashboardsRoute,
	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: { menuId: MENU_ID.INSIGHT },
		component: isNewReportsNavExperienceEnabled()
			? componentWithCondition(getWillShowNav4, DashboardsListPage, AssetsReportsNav4HomePage)
			: () => <Redirect to="/jira/servicedesk/assets/reports" />,
		resources: [
			...getNavigationResources(),
			...getServicedeskPageContextResources(),
			workspaceResource,
		],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsDashboardsRouteEntry.tsx',
				whichExportToUse: 'servicedeskCmdbAssetsDashboardsRouteEntry',
			},
			enabled: true,
		},
	}),
);
